/* eslint-disable react-hooks/exhaustive-deps */
import moment from "moment";
import React, { useEffect, useRef, useState } from "react";
import { Dropdown } from "react-bootstrap";
import DropdownMenu from "react-bootstrap/esm/DropdownMenu";
import qs from "query-string";
import fileDownload from "js-file-download";

import * as S from "./style";
//import { DateRange } from 'react-date-range';
//import { pt } from 'date-fns/locale';
//import useDraggableScroll from 'use-draggable-scroll';
import HeaderUserButton from "../LogOut";

import Loading from "../../../../img/loading-roll.svg";
import ArrowDownWhite from "../../../../img/arrow_dropdown-white.svg";
import ArrowLeftWhite from "../../../../img/arrow_left-white.svg";
import ArrowRightWhite from "../../../../img/arrow_right-white.svg";
//import ArrowDownDark from '../../../../img/arrow_dropdown-dark.svg';
import link_white from "../../../../img/link_white.svg";

import WhatsWhite from "../../../../img/whatsapp_white.svg";
import SmsWhite from "../../../../img/sms_white.svg";
import EmailWhite from "../../../../img/email_white.svg";
// import Pagination from '@material-ui/lab/Pagination';
import api from "../../../../services/api";
//import { X_FOWARD_HOST } from '../../../../utils/env';
import { LinkPagamento, Transacao } from "../../../../model/model";
import { DebouncerInput } from "../input";
import { SingleDropdownCalendar } from "../CalendarContainer";
import { CopyToClipboard } from "react-copy-to-clipboard";

import search_not_found from "../../../../img/search_not_found.svg";
import LinkModal, { LinkModalFilled } from "./linkModal";

import Toast from "react-bootstrap/Toast";
import { IconButton } from "@mui/material";
import ModalInfo from "./linkModal/modalInfo";
import axios from "axios";
// import ToastContainer from 'react-bootstrap/ToastContainer';
const pageLimit = 40;

// const sleep = (m: number) => new Promise((r) => setTimeout(r, m));

export default function LinksDePagamento() {
  const [filtroDia, setFiltroDia] = useState("hoje");
  const [pontovenda, setPontovenda] = useState({ label: "Todos", value: "" });
  const [tipo, setTipo] = useState({ label: "Todos", value: "" });
  const [situation, setSituation] = useState({ label: "Todos", value: "" });

  const [nome, setNome] = useState("");
  //const [pagamentos, setPagamentos] = useState<Pagamento[]>([]);
  const [links, setLinksDePagamento] = useState<LinkPagamento[]>([]);

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [total, setTotal] = useState(0);
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [valorTotal, setValorTotal] = useState(0);
  const [nPagina, setNPagina] = useState(0);
  const [paginaAtual, setPaginaAtual] = useState(1);
  const [paginaVisivel, setPaginaVisivel] = useState(1);

  const [loading, setLoading] = useState(false);
  const headerData = [
    { dia: "hoje" },
    { dia: "ontem" },
    { dia: "este mês" },
    //{ dia: 'personalizado', personalizado: true },
  ];
  const tipos = [
    { label: "Todos", value: "" },
    { label: "Débito", value: "1" },
    { label: "Crédito", value: "2" },
  ];

  const situacoes = [
    { label: "Todos", value: "" },
    { label: "Paga", value: "1" },
    { label: "Cancelada", value: "2" },
    { label: "Processando", value: "0" },
    { label: "Falha", value: "3" },
    { label: "CHARGEBACK", value: "4" },
    { label: "Bloqueada", value: "5" },
  ];

  /**
	 * const situacoes = [
		{ label: 'Todos', value: '' },
		{ label: 'Processando', value: '5' },
		{ label: 'Pendente', value: '4' },
		{ label: 'Em andamento', value: '1' },
		{ label: 'Falha', value: '3' },
		{ label: 'CHARGEBACK', value: '8' },
		{ label: 'Cancelado', value: '2' },
	];
	 */

  const [pontosVenda, setPontosVenda] = useState([
    {
      label: "Todos",
      value: "",
    },
  ]);

  const [rangeHeader, setRangeHeader] = useState([
    {
      startDate: moment(moment().format("DD/MM/YYYY"), "DD/MM/YYYY").toDate(),
      endDate: moment(moment().format("DD/MM/YYYY"), "DD/MM/YYYY").toDate(),
      key: "selection",
    },
  ]);

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [loadingExport, setLoadingExport] = useState(false);

  function handleThisPage(newPage: number) {
    setPaginaAtual(newPage);
    //setVisiblePage(newPage)
  }

  function handleRange(dia: string) {
    const p = [
      {
        dia: "hoje",
        f: function () {
          setRangeHeader([
            {
              startDate: moment(
                moment().format("DD/MM/YYYY"),
                "DD/MM/YYYY"
              ).toDate(),
              endDate: moment(
                moment().format("DD/MM/YYYY"),
                "DD/MM/YYYY"
              ).toDate(),
              key: "selection",
            },
          ]);
        },
      },
      {
        dia: "ontem",
        f: function () {
          setRangeHeader([
            {
              startDate: moment(
                moment().subtract(1, "days").format("DD/MM/YYYY"),
                "DD/MM/YYYY"
              ).toDate(),
              endDate: moment(
                moment().subtract(1, "days").format("DD/MM/YYYY"),
                "DD/MM/YYYY"
              ).toDate(),
              key: "selection",
            },
          ]);
        },
      },
      {
        dia: "este mês",
        f: function () {
          setRangeHeader([
            {
              startDate: moment().startOf("month").toDate(),
              endDate: moment(
                moment().format("DD/MM/YYYY"),
                "DD/MM/YYYY"
              ).toDate(),
              key: "selection",
            },
          ]);
        },
      },
      { dia: "personalizado", f: function () {} },
    ];
    const item = p.find((d) => d.dia === dia);
    if (item) {
      item.f();
    }
  }

  async function getTransacoes() {
    const di = moment(rangeHeader[0].startDate).format("DD%2FMM%2FYYYY");
    const df = moment(rangeHeader[0].endDate).format("DD%2FMM%2FYYYY");

    //console.log(di, df);
    setLoading(true);
    try {
      const urlD = `/admin/transacao/json?q=${nome}&data_inicial=${di}&data_final=${df}&unidade=${
        pontovenda.value
      }&tipo=${tipo.value}&status=${
        situation.value
      }&offset=${0}&limit=${pageLimit}`;
      const urlN = `admin/link?q=${nome}&data_inicial=${di}&data_final=${df}&unidade=${
        pontovenda.value
      }&tipo=${tipo.value}&status=${
        situation.value
      }&offset=${0}&limit=${pageLimit}`;
      const response = await api.get(urlN);
      const { data, status } = response;

      if (status === 200) {
        console.log(data);
        if (data.links) {
          setLinksDePagamento([...data.links]);
        } else {
          setLinksDePagamento([]);
        }
        if (data.total) {
          setTotal(data.total);
          setValorTotal(parseFloat(data.valor) || 0);
          const t = data.total;
          const floorMax = Math.floor(t / pageLimit);
          if (t % pageLimit !== 0) {
            setNPagina(floorMax + 1);
          } else {
            setNPagina(floorMax);
          }
          setPaginaAtual(1);
        } else {
          setTotal(0);
          setValorTotal(0);
          setNPagina(0);
          setPaginaAtual(1);
        }
        setLoading(false);
      }
    } catch (error: any) {
      console.log(error);
      if (error && error.response && error.response.status === 401) {
        window.location.reload();
      }
      setLoading(false);
    }
  }

  async function changePageTransacoes() {
    const di = moment(rangeHeader[0].startDate).format("DD%2FMM%2FYYYY");
    const df = moment(rangeHeader[0].endDate).format("DD%2FMM%2FYYYY");

    //console.log(di, df);
    setLoading(true);
    try {
      const urlD = `/admin/transacao/json?q=${nome}&data_inicial=${di}&data_final=${df}&unidade=${
        pontovenda.value
      }&tipo=${tipo.value}&status=${situation.value}&offset=${
        (paginaAtual - 1) * pageLimit
      }&limit=${pageLimit}`;
      const urlN = `admin/link?q=${nome}&data_inicial=${di}&data_final=${df}&unidade=${
        pontovenda.value
      }&tipo=${tipo.value}&status=${situation.value}&offset=${
        (paginaAtual - 1) * pageLimit
      }&limit=${pageLimit}`;
      const response = await api.get(urlN);
      const { data, status } = response;

      if (status === 200) {
        if (data.links) {
          setLinksDePagamento([...data.links]);
        } else {
          setLinksDePagamento([]);
        }
        if (data.total) {
          setTotal(data.total);
          setValorTotal(parseFloat(data.valor) || 0);
          const t = data.total;
          const floorMax = Math.floor(t / pageLimit);
          if (t % pageLimit !== 0) {
            setNPagina(floorMax + 1);
          } else {
            setNPagina(floorMax);
          }
          //setPaginaAtual(1);
        } else {
          setTotal(0);
          setValorTotal(0);
          setNPagina(0);
          setPaginaAtual(1);
        }
        setLoading(false);
      }
    } catch (error: any) {
      console.log(error);
      if (error.response.status === 401) {
        window.location.reload();
      }
      setLoading(false);
    }
  }

  async function getPontosVenda() {
    try {
      const response = await api.get("/admin/unidade/json");
      const { data, status } = response;
      if (status === 200) {
        if (data.unidades) {
          const listaUni = [{ label: "Todos", value: "" }];
          data.unidades.forEach((d: any) =>
            listaUni.push({ label: d.nome, value: d.id })
          );
          setPontosVenda([...listaUni]);
          //console.log(data.unidades);
        }
      }
    } catch (error) {
      console.log(error);
    }
  }

  useEffect(() => {
    getPontosVenda();
  }, []);

  useEffect(() => {
    // getPagamentos();
    getTransacoes();
    //const di = moment(rangeHeader[0].startDate).format('DD%2FMM%2FYYYY');
    //const df = moment(rangeHeader[0].endDate).format('DD%2FMM%2FYYYY');

    //console.log(di, df);
  }, [rangeHeader, nome, pontovenda, tipo, situation]);

  useEffect(() => {
    // changePage();
    setPaginaVisivel(paginaAtual);
    changePageTransacoes();
    //const di = moment(rangeHeader[0].startDate).format('DD%2FMM%2FYYYY');
    //const df = moment(rangeHeader[0].endDate).format('DD%2FMM%2FYYYY');

    //console.log(di, df);
  }, [paginaAtual]);

  async function getRelatorio(formato: string) {
    // let qparams = Object.assign({}, params);
    setLoadingExport(true);

    const data_inicial = moment(rangeHeader[0].startDate).format("DD/MM/YYYY");
    const data_final = moment(rangeHeader[0].endDate).format("DD/MM/YYYY");

    //unidade:pontovenda.value,tipo:tipo.value,status:situation.value,
    let qsx = qs.stringify(
      Object.assign({
        formato: formato,
        data_inicial,
        data_final,
        unidade: pontovenda.value,
        tipo: tipo.value,
        status: situation.value,
      })
    );

    ////console.log(qparams);
    //	//console.log(qsx);
    try {
      // await 	sleep(2000)

      const response = await api.get(
        `/admin/transacao/relatorio?${qsx}`,

        {
          responseType: "blob",
          headers: { Accept: "application/pdf" },
        }
      );

      const { data } = response;

      if (data) {
        const startDate = moment(rangeHeader[0].startDate).format("DD-MM-YYYY");
        const endDate = moment(rangeHeader[0].endDate).format("DD-MM-YYYY");

        fileDownload(
          response.data,
          `relatorio_${startDate}_${endDate}.${formato}`
        );
      }

      setLoadingExport(false);

      /*	const response = await api.get('/admin/transacao/relatorio?' + qsx, {
				responseType: 'blob',
				headers: { Accept: 'application/pdf' },
			});*/
      //	//console.log(response);

      //	//console.log(response.data);

      /*if (response.data && response.status === 200) {
				if (formato === 'pdf') {
					//const url = URL.createObjectURL(response.data);
					//window.open(url);

					fileDownload(
						response.data,
						`relatorio${qparams.data_inicial}_${qparams.data_final}.${formato}`
					);
					setLoadDownload(false);

					/*const blob = new Blob([response.data], { type: 'application/pdf' });
					if (blob) {
						const url = URL.createObjectURL(blob);
						window.open(url);
					}
				} else {
					fileDownload(
						response.data,
						`relatorio${qparams.data_inicial}_${qparams.data_final}.${formato}`
					);
					setLoadDownload(false);
				}
			}*/
    } catch (error: any) {
      //alert('error: ' + error);
      if (error && error.response && error.response.status === 401) {
        window.location.reload();
      }
      setLoadingExport(false);
    }
  }

  const [modalVisible, setModalVisible] = useState(false);
  const [modalDetails, setModalDetails] = useState(false);
  const [selectedDetailLink, setSelectedDetailLink] = useState<
    LinkPagamento | undefined
  >();
  const [selectedLink, setSelectedLink] = useState<LinkPagamento | undefined>();
  const [copyLink, setCopyLink] = useState(false);
  const [modalInfo, setModalInfo] = useState(false);

  const [defaultSelectedType, setDefaultSelectedType] = useState<
    string | undefined
  >();

  async function sendEmailSmsWhats(type: string, content: any) {
    try {
      const uname = process.env.REACT_APP_UNAME || "";
      const pass = process.env.REACT_APP_PASS || "";
      const url =
        type === "mail"
          ? "https://bot-rpa.metasix.solutions/api/v1/mail-sms-whats"
          : type === "whatsapp"
          ? " https://api-chatbot.amazonasenergia.com/api/stone/whatsapp"
          : "https://api-chatbot.amazonasenergia.com/api/stone/sms";
      const postData = type === "mail" ? { type, content } : content;
      
      const token2 = `${process.env.REACT_APP_SMSWHATS_TOKEN}`
      const response = await axios.post(
        url,
        postData,
        type === "mail"
          ? {
              auth: {
                username: uname,
                password: pass,
              },
            }
          : {
            
              headers: {
                Authorization: `Bearer ${token2}`,
              },
            }
      );

      if (response.data) {
        return true;
      }
    } catch (error) {
      console.log(error);
      return false;
    }
    return false;
  }
  return (
    <S.Container>
      {modalDetails && selectedDetailLink && (
        <LinkModalFilled
          modalVisible={modalDetails}
          setModalVisible={(b: boolean) => {
            setModalDetails(b);
            if (!b) {
              setSelectedDetailLink(undefined);
            }
          }}
          getTransacoes={getTransacoes}
          selectedLink={selectedDetailLink}
        />
      )}
      {modalVisible && (
        <LinkModal
          // link={selectedLink}
          modalVisible={modalVisible}
          setModalVisible={(b: boolean) => {
            setModalVisible(b);
            if (!b) {
              setSelectedLink(undefined);
            }
          }}
          getTransacoes={getTransacoes}
        />
      )}

      {modalInfo && selectedLink && (
        <ModalInfo
          modalVisible={modalInfo}
          setModalVisible={(b: boolean) => {
            setModalInfo(b);
            if (!b) {
              setSelectedLink(undefined);
            }
          }}
          // type={modalInfoType}
          sendEmailSmsWhats={sendEmailSmsWhats}
          createdLink={selectedLink}
          defaultSelectedType={defaultSelectedType}
        />
      )}

      {copyLink && (
        <Toast
          style={{
            position: "absolute",
            bottom: "24px",
            left: "12px",
            height: "48px",
            zIndex: 20,
            background: "#6f6f6f",
          }}
        >
          <Toast.Body>
            <span style={{ color: "#ffffff" }}>
              Link copiado para a área de transferencia.
            </span>
          </Toast.Body>
        </Toast>
      )}

      <S.Header className="mr-30">
        <S.HeaderContainer>
          <S.HeaderTitle>
            {
              // <span className="parent_header">Pagamentos</span>
            }
            {
              // <img src={NavigateNextGreen} alt=">" className="next_item" />
            }
            <span>Links de pagamento</span>
          </S.HeaderTitle>
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
              paddingRight: 16,
            }}
          >
            {/*headerData.map((data) => {
              return (
                <S.HeaderButton
                  key={data.dia}
                  onClick={(e) => {
                    e.preventDefault();
                    setFiltroDia(data.dia);
                    handleRange(data.dia);
                  }}
                  active={data.dia === filtroDia}
                >
                  <p>{data.dia}</p>
                </S.HeaderButton>
              );
            })*/}
            {/*<SingleDropdownCalendar
              item={filtroDia}
              setItem={setFiltroDia}
              range={rangeHeader}
              setRange={setRangeHeader}
            />*/}

            {/*<Dropdown>
              <Dropdown.Toggle className="dropdown-none">
                <S.HeaderExport>
                  <span className="ExportDropdown">
                    {!loadingExport ? (
                      "Exportar"
                    ) : (
                      <img alt="loading" src={Loading} />
                    )}
                  </span>
                  <img
                    className="ExportArrowDown"
                    alt=""
                    src={ArrowDownWhite}
                  />
                </S.HeaderExport>
              </Dropdown.Toggle>
              <Dropdown.Menu>
                <S.ExportHeaderMenu>
                  <div className="export_header_menu_title">
                    Exportar relatório
                  </div>
                  <Dropdown.Item
                    onSelect={(e) => {
                      //e.preventDefault();
                      getRelatorio("pdf");
                    }}
                  >
                    Baixar PDF
                  </Dropdown.Item>
                  <Dropdown.Item
                    onSelect={(e) => {
                      //e.preventDefault();
                      getRelatorio("xls");
                    }}
                  >
                    Baixar XLS
                  </Dropdown.Item>
                </S.ExportHeaderMenu>
              </Dropdown.Menu>
            </Dropdown>*/}
          </div>
        </S.HeaderContainer>
        <HeaderUserButton />
      </S.Header>
      <S.Body className="mr-30">
        <S.RelatoriosContainer>
          <S.RelatoriosSelectContainer
            onSubmit={(e) => {
              e.preventDefault();
            }}
            style={{ justifyContent: "flex-end" }}
          >
            <S.NewButton
              onClick={(e) => {
                e.preventDefault();
                e.stopPropagation();
                setModalVisible(true);
              }}
            >
              <img alt="link" src={link_white} />
              <span>Novo link</span>
            </S.NewButton>
            {/* <DebouncerInput
              placeholder="Cliente, atk, uc"
              setSearchItem={setNome}
              searchItem={nome}
            /> */}
            {/* <S.SearchSelector
              onClick={(e) => {
                e.preventDefault();
                setTipo({ value: "", label: "Todas as formas" });
                setSituation({ value: "", label: "Todas as situações" });
                setPontovenda({ value: "", label: "Todas as empresas" });
                setNome("");
              }}
              active={
                nome === "" &&
                situation.value === "" &&
                pontovenda.value === "" &&
                tipo.value === ""
              }
            >
              TUDO
            </S.SearchSelector>
*/}
            {/*<DropdownContainer
              dropdownItem={tipo}
              setDropdownItem={setTipo}
              dropdownList={tipos}
              defaultLabel="Tipo"
            />*/}
            {/*<DropdownContainer
              dropdownItem={situation}
              setDropdownItem={setSituation}
              dropdownList={situacoes}
              defaultLabel="Situação"
            />*/}
            {/*<DropdownContainerSearch
              dropdownItem={pontovenda}
              setDropdownItem={setPontovenda}
              dropdownList={pontosVenda}
              defaultLabel="Unidade"
            />*/}
          </S.RelatoriosSelectContainer>

          {nPagina > 1 && (
            <div className="pagination_container">
              <p className="pagination_text">
                {"Mostrando "}
                <span className="pagination_text_bold">
                  {`${(paginaAtual - 1) * pageLimit + 1} - ${
                    total > paginaAtual * pageLimit
                      ? paginaAtual * pageLimit
                      : total
                  }`}
                </span>
                {" de "}
                {`${total} pagamentos`}
              </p>
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "center",
                }}
              >
                <form
                  onSubmit={(e) => {
                    e.preventDefault();
                    handleThisPage(paginaVisivel);
                  }}
                  className="table_footer_border_right table_footer_padding_right-20"
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    alignItems: "center",
                  }}
                >
                  <p className="table_footer_label">Você está na página </p>
                  <input
                    className="table_footer_input"
                    type="tel"
                    value={paginaVisivel}
                    onChange={(e) => {
                      let value = e.target.value;
                      value = value.replace(/\D/g, "");

                      if (value.length > 0) {
                        let intValue = parseInt(value);
                        if (intValue > nPagina) {
                          setPaginaVisivel(nPagina);
                        } else setPaginaVisivel(intValue);
                      } else {
                        setPaginaVisivel(0);
                      }
                    }}
                  />
                  <p className="table_footer_label">de {nPagina} </p>
                </form>
                <div className="table_footer_button_container table_footer_margin_left-20 table_footer_border_right-12 table_footer_border_left-12">
                  <button
                    onClick={(e) => {
                      e.preventDefault();
                      if (paginaVisivel > 1) {
                        handleThisPage(paginaVisivel - 1);
                      }
                    }}
                    className="table_footer_button table_footer_border_left-12"
                  >
                    <img alt="<" src={ArrowLeftWhite} />
                  </button>
                  <button
                    onClick={(e) => {
                      e.preventDefault();
                      if (paginaVisivel !== nPagina) {
                        handleThisPage(paginaVisivel + 1);
                      }
                    }}
                    className="table_footer_button table_footer_border_right-12"
                  >
                    <img alt=">" src={ArrowRightWhite} />
                  </button>
                </div>
              </div>
              {/*<Pagination
								className='align-self-right'
								shape='rounded'
								count={nPagina}
								siblingCount={2}
								boundaryCount={2}
								page={paginaAtual}
								onChange={(event, value) => {
									setPaginaAtual(value);
									//getPagamentosChangePage(value);
								}}
							/>*/}
            </div>
          )}
          <div>
            <S.TableContainer
              pagShowing={nPagina > 1 || (!loading && links.length === 0)}
              className="mt-15"
            >
              <S.Table>
                <S.THead>
                  <tr>
                    <S.Th>Data</S.Th>
                    <S.Th>UC/Cliente</S.Th>
                    <S.Th>Valor total</S.Th>
                    <S.Th>Canal</S.Th>
                    <S.Th>Status</S.Th>
                    <S.Th></S.Th>
                  </tr>
                </S.THead>
                <S.TBody>
                  {/*pagamentos.map((p) => (
										<TRItem pagamento={p} />
									))*/}

                  {loading ? (
                    <S.BodyTR>
                      <td>
                        <S.Skeleton style={{ width: "100%", height: 32 }} />
                      </td>
                      <td>
                        <S.Skeleton style={{ width: "100%", height: 32 }} />
                      </td>
                      <td>
                        <S.Skeleton style={{ width: "100%", height: 32 }} />
                      </td>
                      <td>
                        <S.Skeleton style={{ width: "100%", height: 32 }} />
                      </td>
                      <td>
                        <S.Skeleton style={{ width: "100%", height: 32 }} />
                      </td>
                      <td>
                        <S.Skeleton style={{ width: "100%", height: 32 }} />
                      </td>
                    </S.BodyTR>
                  ) : links.length > 0 ? (
                    links.map((t) => (
                      <TRItemTransacao
                        link={t}
                        getTransacoes={getTransacoes}
                        copyLink={copyLink}
                        setCopyLink={setCopyLink}
                        openDetails={({
                          visible,
                          selectedLink,
                        }: {
                          visible: boolean;
                          selectedLink: LinkPagamento;
                        }) => {
                          setModalDetails(visible);
                          setSelectedDetailLink(selectedLink);
                        }}
                        setSelectedLinkCopy={({
                          visible,
                          selectedLink,
                          defaultType,
                        }: {
                          visible: boolean;
                          selectedLink: LinkPagamento;
                          defaultType?: string;
                        }) => {
                          setModalInfo(visible);
                          setSelectedLink(selectedLink);
                          if (defaultType) {
                            setDefaultSelectedType(defaultType);
                          } else setDefaultSelectedType(undefined);
                        }}
                      />
                    ))
                  ) : null}
                </S.TBody>
              </S.Table>
              {!loading && links.length === 0 && (
                <S.NotFoundContainer>
                  <img alt="nao encontrado" src={search_not_found} />
                </S.NotFoundContainer>
              )}

              {!loading && links.length === 0 && (
                <div className="pagination_container">
                  <div className="not_found_text">
                    {" "}
                    Não existem resultados para a data selecionada{" "}
                  </div>
                </div>
              )}
            </S.TableContainer>
          </div>
          <div style={{ height: 25 }} />
        </S.RelatoriosContainer>
      </S.Body>
    </S.Container>
  );
}

function TRItemTransacao({
  link,
  getTransacoes,

  setSelectedLinkCopy,
  copyLink,
  setCopyLink,
  openDetails,
}: {
  openDetails({
    visible,
    selectedLink,
  }: {
    visible: boolean;
    selectedLink: LinkPagamento;
  }): void;
  link: LinkPagamento;
  getTransacoes(): void;
  copyLink: boolean;
  setCopyLink(b: boolean): void;
  setSelectedLinkCopy({
    visible,
    selectedLink,
    defaultType,
  }: {
    visible: boolean;
    selectedLink: LinkPagamento;
    defaultType?: string;
  }): void;
}) {
  // const [modalVisible, setModalVisible] = useState(false);
  const situacoes = [
    { label: "Todos", value: "" },
    { label: "Ativo", value: "1" },
    { label: "Finalizado", value: "2" },
    { label: "Rascunho", value: "0" },
    { label: "Cancelado", value: "3" },
    { label: "Removido", value: "4" },
    { label: "Bloqueada", value: "5" },
  ];
  function checkStatus() {
    if (link.expiracao) {
      // console.log(moment().toDate(), moment(link.expiracao).toDate());
      if (!moment(link.expiracao).isAfter()) return "Expirado";
    }

    const f = situacoes.find((s) => parseInt(s.value) === link.status);
    if (f) {
      return f.label;
    } else return "-";
  }

  function checkStatusColor() {
    const colors = [
      {
        value: 4,
        color: "#C90716",
      },
      {
        value: 2,
        color: "#ffaa00",
      },
      {
        value: 1,
        color: "#4BAF50",
      },
      {
        value: 0,
        color: "#676767",
      },
      { value: 3, color: "#000000" },
    ];

    if (link.expiracao) {
      // console.log(moment().toDate(), moment(link.expiracao).toDate());
      if (!moment(link.expiracao).isAfter()) return "#253858";
    }

    const f = colors.find((c) => c.value === link.status);
    if (f) {
      return f.color;
    } else {
      return undefined;
    }
  }

  function checkStatusBackgroundColor() {
    const colors = [
      {
        value: 4,
        color: "#FCEAE6",
      },
      {
        value: 2,
        color: "#ffc34a",
      },
      {
        value: 1,
        color: "#E8F5EC",
      },
      {
        value: 0,
        color: "#676767",
      },
      { value: 3, color: "#000000" },
    ];

    if (link.expiracao) {
      // console.log(moment().toDate(), moment(link.expiracao).toDate());
      if (!moment(link.expiracao).isAfter()) return "#E8EAEE";
    }

    const f = colors.find((c) => c.value === link.status);
    if (f) {
      return f.color;
    } else {
      return undefined;
    }
  }

  function getDay() {
    if (link && link.pagamento && link.pagamento.cadastro) {
      const d = moment(link.pagamento.cadastro).format("DD/MM/YYYY") || "-";

      return d;
    }
    return "-";
  }

  function getHour() {
    if (link && link.pagamento && link.pagamento.cadastro) {
      const h = moment(link.pagamento.cadastro).format("HH:mm:ss") || "-";

      return h;
    }
    return "-";
  }

  return (
    <S.BodyTR>
      <td>
        <div>
          <p className="td_text">{getDay()}</p>
          <p className="td_subtext">{getHour()}</p>

          {
            // <S.TdStatus color={checkStatusColor()}>{checkStatus()}</S.TdStatus>
          }
        </div>
      </td>
      <td>
        <div>
          {
            <p className="td_text">
              {link && link.pagamento && link.pagamento?.uc
                ? link.pagamento?.uc
                : "SEM UC"}
            </p>
          }
          {
            <p className="td_subtext">
              {link && link.pagamento && link.pagamento?.cliente
                ? link.pagamento?.cliente
                : ""}
            </p>
          }
        </div>
      </td>
      <td>
        <p className="td_text">
          {link && link.pagamento && link.pagamento.total
            ? `R$ ${parseFloat(`${link.pagamento.total}`).toLocaleString(
                "pt-BR",
                {
                  minimumFractionDigits: 2,
                }
              )}`
            : "R$ 0,00"}
        </p>

        {
          //<p className="td_text">{getDay()}</p>
        }
        {
          //<p className="td_subtext">{getHour()}</p>
        }

        {/*<p className="td_item">{`R$ ${parseFloat(
          transacao.valor
        ).toLocaleString("pt-BR", {
          minimumFractionDigits: 2,
        })}`}</p>*/}
      </td>

      <td>
        <S.ChannelRow>
          <IconButton
            onClick={(e) => {
              e.preventDefault();
              e.stopPropagation();
              setSelectedLinkCopy({
                visible: true,
                selectedLink: link,
                defaultType: "whatsapp",
              });
            }}
            className="channel_item"
          >
            <img alt="whats" src={WhatsWhite} />
          </IconButton>
          <IconButton
            onClick={(e) => {
              e.preventDefault();
              e.stopPropagation();
              setSelectedLinkCopy({
                visible: true,
                selectedLink: link,
                defaultType: "sms",
              });
            }}
            className="channel_item"
          >
            <img alt="sms" src={SmsWhite} />
          </IconButton>
          <IconButton
            onClick={(e) => {
              e.preventDefault();
              e.stopPropagation();
              setSelectedLinkCopy({
                visible: true,
                selectedLink: link,
                defaultType: "mail",
              });
            }}
            className="channel_item"
          >
            <img alt="email" src={EmailWhite} />
          </IconButton>
        </S.ChannelRow>
        {/*<CopyToClipboard
          text={`${process.env.REACT_APP_LINK_REDIRECT}pagamento/link/${link.id}?secret=${link.secret}`}
        >
          <S.Detalhes
            onClick={(e) => {
              e.preventDefault();
              if (!copyLink) {
                setCopyLink(true);
                setTimeout(() => {
                  setCopyLink(false);
                }, 5000);
              }
              //setSelectedLink({ visible: true, selectedLink: link });
            }}
          >
            {" "}
            Copiar link
          </S.Detalhes>
        </CopyToClipboard>*/}
      </td>

      <td>
        <div>
          <S.TdStatus
            backgroundColor={checkStatusBackgroundColor()}
            color={checkStatusColor()}
          >
            <span> {checkStatus()}</span>
          </S.TdStatus>
        </div>
      </td>
      <td>
        <CopyToClipboard
          text={`${process.env.REACT_APP_LINK_REDIRECT}pagamento/link/${link.id}?secret=${link.secret}`}
        >
          <S.Detalhes
            // style={{ display: "none" }}
            onClick={(e) => {
              e.preventDefault();

              openDetails({
                visible: true,
                selectedLink: link,
              });
              //setSelectedLink({ visible: true, selectedLink: link });
            }}
          >
            {" "}
            Detalhes
          </S.Detalhes>
        </CopyToClipboard>
      </td>
    </S.BodyTR>
  );
}

function DropdownContainer({
  dropdownItem,
  setDropdownItem,
  dropdownList,
  defaultLabel,
}: {
  dropdownItem: { label: string; value: string };
  setDropdownItem(d: { label: string; value: string }): void;
  dropdownList: { label: string; value: string }[];
  defaultLabel: string;
}) {
  const dropdownRef = useRef<any>(null);
  const [dropdownOpen, setDropdownOpen] = useState(false);
  useOutsideAlert(dropdownRef, handleClickOutsideDropdown);

  function handleClickOutsideDropdown(e: any) {
    if (
      dropdownRef.current &&
      dropdownRef.current !== null &&
      !dropdownRef.current.contains(e.target)
    ) {
      setDropdownOpen(false);
    }
  }
  return (
    <Dropdown ref={dropdownRef} show={dropdownOpen}>
      <Dropdown.Toggle
        onClick={(e) => {
          e.preventDefault();
          e.stopPropagation();
          setDropdownOpen(!dropdownOpen);
        }}
        style={{ padding: 0 }}
        className="dropdown-toggle-categoria"
      >
        <S.SearchSelector
          onClick={(e) => {
            e.preventDefault();
          }}
          pressed={dropdownOpen}
          active={dropdownItem.value !== ""}
        >
          {dropdownItem.value === "" ? defaultLabel : dropdownItem.label}
          {dropdownItem.value !== "" && (
            <img className="ExportArrowDown" alt="" src={ArrowDownWhite} />
          )}
        </S.SearchSelector>
      </Dropdown.Toggle>
      <DropdownMenu
        style={{
          background: "transparent",
          border: 0,
          marginTop: -10,
        }}
      >
        <S.SelectMenu>
          {dropdownList.map((e) => {
            return (
              <Dropdown.Item
                style={{ padding: 0 }}
                //className='dropdown-item-categoria'
                onClick={(a) => {
                  a.preventDefault();
                  a.stopPropagation();
                  setDropdownItem({
                    value: e.value,
                    label: e.label,
                  });
                  setDropdownOpen(false);
                }}
              >
                <S.SelectItem active={dropdownItem.value === e.value}>
                  {e.label}
                </S.SelectItem>
              </Dropdown.Item>
            );
          })}
        </S.SelectMenu>
      </DropdownMenu>
    </Dropdown>
  );
}

function DropdownContainerSearch({
  dropdownItem,
  setDropdownItem,
  dropdownList,
  defaultLabel,
}: {
  dropdownItem: { label: string; value: string };
  setDropdownItem(d: { label: string; value: string }): void;
  dropdownList: { label: string; value: string }[];
  defaultLabel: string;
}) {
  const dropdownRef = useRef<any>(null);
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [searchItem, setSearchItem] = useState("");
  useOutsideAlert(dropdownRef, handleClickOutsideDropdown);

  function handleClickOutsideDropdown(e: any) {
    if (
      dropdownRef.current &&
      dropdownRef.current !== null &&
      !dropdownRef.current.contains(e.target)
    ) {
      setDropdownOpen(false);
    }
  }
  return (
    <Dropdown ref={dropdownRef} show={dropdownOpen}>
      <Dropdown.Toggle
        onClick={(e) => {
          e.preventDefault();
          e.stopPropagation();
          setDropdownOpen(!dropdownOpen);
        }}
        style={{ padding: 0 }}
        className="dropdown-toggle-categoria"
      >
        <S.SearchSelector
          onClick={(e) => {
            e.preventDefault();
          }}
          pressed={dropdownOpen}
          active={dropdownItem.value !== ""}
        >
          {dropdownItem.value === "" ? defaultLabel : dropdownItem.label}
          {dropdownItem.value !== "" && (
            <img className="ExportArrowDown" alt="" src={ArrowDownWhite} />
          )}
        </S.SearchSelector>
      </Dropdown.Toggle>
      <DropdownMenu
        style={{
          background: "transparent",
          border: 0,
          marginTop: -10,
        }}
      >
        <S.SelectSearchMenu style={{ background: "#FFFFFF" }}>
          <Dropdown.Item
            style={{ padding: 0 }}
            //className='dropdown-item-categoria'
            onClick={(a) => {
              a.preventDefault();
              a.stopPropagation();
              setDropdownItem({
                value: "",
                label: "",
              });
              setDropdownOpen(false);
            }}
          >
            <S.SelectItem style={{ maxWidth: 100 }} active={true}>
              {"Todas"}
            </S.SelectItem>
          </Dropdown.Item>

          <DebouncerInput
            searchItem={searchItem}
            setSearchItem={setSearchItem}
            placeholder="Buscar unidade"
          />

          <div style={{ marginTop: 16 }} className="scroll-container">
            {dropdownList.map((e) => {
              if (e.label.includes(searchItem))
                return (
                  <Dropdown.Item
                    style={{ padding: 0 }}
                    //className='dropdown-item-categoria'
                    onClick={(a) => {
                      a.preventDefault();
                      a.stopPropagation();
                      setDropdownItem({
                        value: e.value,
                        label: e.label,
                      });
                      setDropdownOpen(false);
                    }}
                  >
                    <S.SelectItemList>{e.label}</S.SelectItemList>
                  </Dropdown.Item>
                );

              return null;
            })}
          </div>
        </S.SelectSearchMenu>
      </DropdownMenu>
    </Dropdown>
  );
}

function useOutsideAlert(ref: any, handleClickOutside: any) {
  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      // Unbind the event listener on clean up
      document.removeEventListener("mousedown", handleClickOutside);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [ref]);
}

/**
 *
					<S.RelatoriosSelectContainer
						onSubmit={(e) => {
							e.preventDefault();
							// getPagamentos();
							getTransacoes();
						}}
						className='mb-15 justify_content_between'>
						<S.RelatorioItem width={'280'}>
							{<p className='label_title'>Pesquisar por</p>}
							<input
								placeholder='Nome do Cliente, ATK ou UC'
								type='text'
								className='relatorios_input'
								value={nome}
								onChange={(e) => {
									setNome(e.target.value);
								}}
							/>
						</S.RelatorioItem>

						<S.RelatorioItem width={'170'}>
							<p className='label_title'>Tipo</p>

							<Dropdown>
								<Dropdown.Toggle className='dropdown-none'>
									<S.FilterDropdown width={'170'}>
										<span className='ExportDropdown'>{tipo.label}</span>
										<span className='ExportArrowDown'>
											<img
												//className='ExportArrowDown'
												alt=''
												src={ArrowDownDark}
											/>
										</span>
									</S.FilterDropdown>
								</Dropdown.Toggle>
								<Dropdown.Menu>
									{tipos.map((t) => (
										<Dropdown.Item
											onSelect={(e) => {
												setTipo(t);
											}}>
											{t.label}
										</Dropdown.Item>
									))}
								</Dropdown.Menu>
							</Dropdown>
						</S.RelatorioItem>

						<S.RelatorioItem width={'170'}>
							<p className='label_title'>Situação</p>

							<Dropdown>
								<Dropdown.Toggle className='dropdown-none'>
									<S.FilterDropdown width={'170'}>
										<span className='ExportDropdown'>{situation.label}</span>
										<span className='ExportArrowDown'>
											<img
												//className='ExportArrowDown'
												alt=''
												src={ArrowDownDark}
											/>
										</span>
									</S.FilterDropdown>
								</Dropdown.Toggle>
								<Dropdown.Menu>
									{situacoes.map((s) => (
										<Dropdown.Item
											onSelect={(e) => {
												setSituation(s);
											}}>
											{s.label}
										</Dropdown.Item>
									))}
								</Dropdown.Menu>
							</Dropdown>
						</S.RelatorioItem>

						<S.RelatorioItem className='mr-15' width={'200'}>
							<p className='label_title'>Unidade</p>

							<Dropdown>
								<Dropdown.Toggle className='dropdown-none'>
									<S.FilterDropdown width={'200'}>
										<span className='ExportDropdown'>{pontovenda.label}</span>
										<span className='ExportArrowDown'>
											<img
												//className='ExportArrowDown'
												alt=''
												src={ArrowDownDark}
											/>
										</span>
									</S.FilterDropdown>
								</Dropdown.Toggle>
								<Dropdown.Menu>
									{pontosVenda.map((pv) => (
										<Dropdown.Item
											onSelect={(e) => {
												setPontovenda(pv);
											}}>
											{pv.label}
										</Dropdown.Item>
									))}
								</Dropdown.Menu>
							</Dropdown>
						</S.RelatorioItem>

						<S.RelatorioItem width={'140'}>
							<p style={{ color: 'transparent' }} className='label_title'>
								-
							</p>
							<button
								style={{ width: 140 }}
								type='submit'
								className='relatorios_button'>
								Filtrar
							</button>
						</S.RelatorioItem>
					</S.RelatoriosSelectContainer>

 */

/*
function TRItem({ pagamento }: { pagamento: Pagamento }) {
	const [modalVisible, setModalVisible] = useState(false);
	const situacoes = [
		{ label: 'Todos', value: '' },
		{ label: 'Processando', value: '5' },
		{ label: 'Pendente', value: '4' },
		{ label: 'Em andamento', value: '1' },
		{ label: 'Falha', value: '3' },
		{ label: 'CHARGEBACK', value: '8' },
		{ label: 'Cancelado', value: '2' },
	];

	function checkStatus() {
		const f = situacoes.find((s) => parseInt(s.value) === pagamento.status);
		if (f) {
			return f.label;
		} else return '-';
	}

	function checkStatusColor() {
		const colors = [
			{
				value: 4,
				color: '#C90716',
			},
			{
				value: 5,
				color: '#FFAB00',
			},
			{
				value: 1,
				color: '#4BAF50',
			},
			{
				value: 2,
				color: '#4BAF50',
			},
		];

		const f = colors.find((c) => c.value === pagamento.status);
		if (f) {
			return f.color;
		} else {
			return undefined;
		}
	}

	function getDay() {
		const d = moment(pagamento.cadastro).format('DD/MM/YYYY');

		return d;
	}

	function getHour() {
		const h = moment(pagamento.cadastro).format('HH:mm:ss');

		return h;
	}

	return (
		<S.BodyTR>
			<DetalhesPagamento
				//elementId={'modalDetalhes'}
				pagamento={pagamento}
				modalVisible={modalVisible}
				setModalVisible={setModalVisible}
			/>
			<td>
				<div>
					<p className='td_text'>{pagamento.pontoVenda.apelido}</p>
					<S.TdStatus color={checkStatusColor()}>{checkStatus()}</S.TdStatus>
				</div>
			</td>
			<td>
				<div>
					<p className='td_text'>{getDay()}</p>
					<p className='td_subtext'>{getHour()}</p>
				</div>
			</td>
			<td>
				<div>
					<p className='td_text'>{pagamento.uc}</p>
					<p className='td_text'>{pagamento.cliente}</p>
				</div>
			</td>
			<td>
				<p className='td_item'>{`R$ ${pagamento.pago.toLocaleString('pt-BR', {
					minimumFractionDigits: 2,
				})}`}</p>
			</td>
			<td>
				<S.Detalhes
					onClick={(e) => {
						e.preventDefault();
						setModalVisible(true);
					}}>
					{' '}
					Detalhes
				</S.Detalhes>
			</td>
		</S.BodyTR>
	);
}
*/
// usar card modificado para as opcoes de cima
// Copiar modelo de dropdown do exportar
// input de pesquisa baseado no design original do bill
// table inspirada no bill
// lembrar de puxar modal de detalhes ja feito
